// extracted by mini-css-extract-plugin
export default {"roomContainer":"room_info_roomContainer__c+cFg"};